import Head from "next/head";
import { useEffect, useState } from "react";

const Language = (props) => {
  const { customClass } = props
  const [isLanguageSelected, setIsLanguageSelected] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  // useEffect(() => {
  //   const googleTranslateElementInit = () => {
  //     if (window.google && window.google.translate) {
  //       try {
  //         new window.google.translate.TranslateElement(
  //           { pageLanguage: "en" },
  //           "google_translate_element"
  //         );
  //       } catch (error) {
  //         console.error("Google Translate initialization failed", error);
  //       }
  //     }
  //   };

  //   // Load the Google Translate script
  //   const addGoogleTranslateScript = () => {
  //     const script = document.createElement("script");
  //     script.src = "https://translate.google.com/translate_a/element.js";
  //     script.async = true;
  //     script.onload = googleTranslateElementInit; // Initialize after script loads
  //     document.body.appendChild(script);
  //   };

  //   // Ensure the script is only added once
  //   if (
  //     !document.querySelector(
  //       "script[src='https://translate.google.com/translate_a/element.js']"
  //     )
  //   ) {
  //     addGoogleTranslateScript();
  //   } else {
  //     googleTranslateElementInit(); // If script is already there, initialize the element
  //   }
  // }, []);


  return (
    <>
      <div className="flex gap-x-2 h-14 lg:gap-x-[.5vw] items-center relative">
        <div>
          {/* <svg viewBox="3 3.108 18 18"
            className={`hidden ${isHovered ? "text-black" : 'text-white'} lg:inline-block pointer-events-none absolute left-0 bottom-2`}
          >
            <path d="M12,21.108c-1.238,0-2.405-0.237-3.5-0.71c-1.095-0.475-2.048-1.117-2.86-1.93c-0.813-0.813-1.456-1.766-1.929-2.86S3,13.347,3,12.108c0-1.242,0.237-2.41,0.71-3.503S4.827,6.56,5.64,5.748C6.452,4.936,7.405,4.292,8.5,3.819s2.262-0.71,3.5-0.71c1.242,0,2.41,0.237,3.503,0.71s2.046,1.117,2.858,1.929c0.812,0.812,1.455,1.765,1.928,2.857C20.764,9.698,21,10.866,21,12.108c0,1.238-0.236,2.405-0.711,3.5c-0.473,1.095-1.116,2.048-1.928,2.86c-0.813,0.813-1.766,1.455-2.858,1.93C14.41,20.871,13.242,21.108,12,21.108z M12,20.116c0.588-0.754,1.071-1.494,1.451-2.222c0.381-0.727,0.691-1.54,0.93-2.439H9.619c0.264,0.951,0.58,1.79,0.948,2.517C10.935,18.699,11.413,19.414,12,20.116z M10.727,19.967c-0.467-0.551-0.893-1.23-1.278-2.04s-0.672-1.634-0.861-2.472H4.754c0.573,1.243,1.386,2.263,2.438,3.059C8.243,19.311,9.422,19.795,10.727,19.967z M13.273,19.967c1.305-0.172,2.483-0.656,3.535-1.453c1.053-0.796,1.865-1.815,2.438-3.059h-3.834c-0.253,0.851-0.572,1.682-0.957,2.49C14.07,18.756,13.676,19.429,13.273,19.967z M4.346,14.455h4.035c-0.076-0.41-0.129-0.811-0.161-1.199c-0.031-0.39-0.047-0.772-0.047-1.147s0.016-0.758,0.047-1.147s0.085-0.789,0.161-1.199H4.346c-0.109,0.346-0.194,0.723-0.255,1.132C4.03,11.302,4,11.707,4,12.108s0.03,0.806,0.091,1.214C4.152,13.731,4.237,14.108,4.346,14.455z M9.381,14.455h5.238c0.076-0.41,0.129-0.805,0.16-1.18c0.031-0.377,0.047-0.766,0.047-1.167s-0.016-0.79-0.047-1.167c-0.031-0.376-0.084-0.77-0.16-1.18H9.381c-0.076,0.41-0.129,0.804-0.161,1.18c-0.031,0.376-0.047,0.765-0.047,1.167s0.016,0.79,0.047,1.167C9.251,13.65,9.305,14.045,9.381,14.455z M15.619,14.455h4.035c0.108-0.347,0.193-0.724,0.254-1.133C19.97,12.915,20,12.51,20,12.108s-0.03-0.806-0.092-1.214c-0.061-0.409-0.146-0.786-0.254-1.132h-4.035c0.076,0.41,0.129,0.81,0.16,1.199s0.047,0.771,0.047,1.147s-0.016,0.758-0.047,1.147C15.748,13.645,15.695,14.045,15.619,14.455zM15.412,8.762h3.834c-0.586-1.269-1.389-2.289-2.408-3.06c-1.021-0.771-2.209-1.261-3.564-1.471c0.467,0.614,0.886,1.316,1.258,2.107C14.904,7.128,15.197,7.937,15.412,8.762z M9.619,8.762h4.762c-0.264-0.938-0.59-1.787-0.977-2.546C13.017,5.457,12.549,4.752,12,4.101c-0.549,0.651-1.017,1.356-1.404,2.116C10.209,6.975,9.883,7.824,9.619,8.762z M4.754,8.762h3.834c0.214-0.826,0.507-1.634,0.88-2.424c0.373-0.791,0.792-1.493,1.259-2.107c-1.369,0.21-2.561,0.704-3.574,1.481C6.14,6.489,5.34,7.506,4.754,8.762z" />
          </svg> */}
          <svg
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={`${customClass} ${isHovered ? "text-black" : 'text-white'}  pointer-events-none absolute left-[-3px] bottom-[26px] `}

            fill="#000000" width="24px" height="24px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path d="M363,176,246,464h47.24l24.49-58h90.54l24.49,58H480ZM336.31,362,363,279.85,389.69,362Z" />
            <path d="M272,320c-.25-.19-20.59-15.77-45.42-42.67,39.58-53.64,62-114.61,71.15-143.33H352V90H214V48H170V90H32v44H251.25c-9.52,26.95-27.05,69.5-53.79,108.36-32.68-43.44-47.14-75.88-47.33-76.22L143,152l-38,22,6.87,13.86c.89,1.56,17.19,37.9,54.71,86.57.92,1.21,1.85,2.39,2.78,3.57-49.72,56.86-89.15,79.09-89.66,79.47L64,368l23,36,19.3-11.47c2.2-1.67,41.33-24,92-80.78,24.52,26.28,43.22,40.83,44.3,41.67L255,362Z" />
          </svg>

          {
            <div
              id="google_translate_element"
              className="relative flex gap-x-2 lg:gap-x-[.5vw] items-center opacity-0 w-4"
            >
            </div>
          }
        </div>
      </div>

    </>
  );
};

export default Language;
